import { useContext, useEffect, useState } from "react";
import {
  Flex,
  useClipboard,
  useDisclosure,
  useToast,
  Button,
} from "@chakra-ui/react";
import { FaCopy } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { BookingDetails } from "../../Config/Booking";
// import { text } from "stream/consumers";
import { DateTime } from "luxon";
import { MdOutlineDeleteForever } from "react-icons/md";
import { DeletePaymentLinkModal } from "../Modals/DeletePaymentLinkModal";
import { getDurationForSessionType } from "../../Config/Expert";

export const SingleRowAssessmentPayment = ({
  data,
  experts,
  users,
  func,
}: any) => {
 
  const { onCopy, value, setValue, hasCopied } = useClipboard("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modal, setModal] = useState("");
  // console.log(data._id);
  const navigate = useNavigate();

  const [bookingDetails, setBookingDetails] = useState<any>(BookingDetails);
  const [isProvisional, setIsProvisional] = useState<any>(true);

  const formattedDate = (inputDate: string) => {
    const parts = inputDate.split("-");

    if (parts.length === 3) {
      const formattedDate = `${parts[1]}/${parts[2]}/${parts[0]}`;
      return formattedDate;
    }
    return "";
  };

  const currentDate = DateTime.now().toFormat("yyyy-MM-dd");
  const currentTime = DateTime.now().toFormat("HH:mm");

  const sessionCount =
    data.bookingType === "SUBSCRIPTION10"
      ? "10"
      : data.bookingType === "SUBSCRIPTION5"
      ? "5"
      : data.bookingType === "SUBSCRIPTION3"
      ? "3"
      : "1";



  const handleSubmit = () => {
    const expertData = experts?.find((el: any) => el?._id === data.expert);

    let expertInformation = {
      uuid: "",
      full_name: "",
      role: "",
    };

    if (expertData) {
      expertInformation = {
        uuid: expertData._id,
        full_name: expertData.data.full_name,
        role: expertData.data.role,
      };
    }

    const userData = users.find(
      (el: any) =>
        el?.label === data?.customer?.email ||
        el?.phone?.slice(-10) === data?.customer?.contact?.slice(-10)
    );

    let leadInformation = {
      uuid: "",
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
    };

    let isBookingProvisional = true;

    if (userData) {
      isBookingProvisional = false;
      leadInformation = {
        uuid: userData.uuid,
        email: data?.customer?.email,
        first_name: data?.customer?.name,
        last_name: "",
        phone: data?.customer?.contact,
      };
    } else {
      leadInformation = {
        uuid: "",
        email: data?.customer?.email,
        first_name: data?.customer?.name,
        last_name: "",
        phone: data?.customer?.contact,
      };
    }

    const sessionDuration = getDurationForSessionType(
      "personal",
      data.sessionType
    );

    const bookingData = {
      ...bookingDetails,
      non_app: isBookingProvisional,
      booking_date: formattedDate(currentDate),
      booking_time: currentTime,
      booking_type: data.sessionType,
      session_type: "personal",
      session_duration: sessionDuration,
      payment_information: {
        amount: data.amount / 100,
        payment_id: data.payment_id,
      },
      lead_information: leadInformation,
      expert_information: expertInformation,
      cart_information: {
        promocode: "",
        original_price: data.amount / 100,
        final_price: data.amount / 100,
        subscription: false,
        pro: false,
      },
      subscription: {
        session_count: sessionCount,
        price: data.amount / 100,
      },
      expert_billing_details: {
        isCorporate: false,
        booking_source: "OTHER",
      },
    };
    // console.log(bookingData);

    navigate("/provisional/bookings/add", {
      state: {
        bookingData,
        isBookingProvisional,
      },
    });
  };

  useEffect(() => {
    const userData = users.find(
      (el: any) =>
        el?.label === data?.customer?.email ||
        el?.phone?.slice(-10) === data?.customer?.contact?.slice(-10)
    );
    // console.log(userData);
    if (userData) {
      setIsProvisional(false);
    }
  }, [users]);
  useEffect(() => {
    setValue(data.short_url);
    // fetchExperts();
  }, [data]);

  return (
    <tr>
      <td>₹ {data.amount / 100}</td>
      <td className="flex">
        <a href={data.short_url} target="_blank" rel="noopener noreferrer">
          {value}
        </a>
        <button type="button" className="btn" onClick={onCopy}>
          {hasCopied ? (
            <FaCopy style={{ color: "#327171" }} />
          ) : (
            <FaCopy style={{ color: "#f48a0f" }} />
          )}
        </button>
      </td>
      <td>{data.sessionType}</td>
      <td>{data.bookingType}</td>
      <td>
        {experts?.find((el: any) => el?._id === data.expert)?.data?.full_name ||
          data.expert}
      </td>
      {/* <td>{data.expert}</td> */}
      <td>{data?.customer?.name || ""}</td>
      <td>{data?.customer?.contact || ""}</td>
      <td>{data?.customer?.email || ""}</td>
      <td>
        {/* {Object.entries(data.notify)
          .filter(([_, value]) => value)
          .map(([key]) => key.toUpperCase())
          .join(", ")} */}
        <span
          style={{
            color: isProvisional ? "blue" : "green",
            fontWeight: "600",
          }}
        >
          {isProvisional ? "Non app" : "App"}
        </span>
      </td>
      <td>{data.status}</td>
      <td>
        <Button
          fontSize="12px"
          textColor="#fff"
          className={data.is_booking_done ? "" : "btn action-btn"}
          isDisabled={data.status !== "paid" || data.is_booking_done}
          onClick={handleSubmit}
          style={
            data.is_booking_done
              ? {
                  backgroundColor: "#fff",
                  color: "#fdb508",
                  fontWeight: "bolder",
                }
              : {
                  backgroundColor: "#fdb508",
                  color: "white",
                  fontWeight: "bold",
                }
          }
        >
          {data.is_booking_done ? "Booking Added" : "Add Booking"}
        </Button>
      </td>
      <td>
        <div className="d-flex align-items-center">
          <span title="Delete">
            <MdOutlineDeleteForever
              className="deleteButton pointer"
              onClick={() => {
                setModal("deletemodal");
                onOpen();
              }}
            />
          </span>
        </div>
      </td>
      {modal === "deletemodal" && (
              <DeletePaymentLinkModal
                isOpen={isOpen}
                onClose={onClose}
                func={func}
                id={data.id}
                price={data.amount / 100}
              />
            )}
    </tr>
  );
};
